import React from "react";
import Link from "next/link";
import { getAssets } from "@unisearch/helpers";
import styles from "./tem_two_profile_matching.module.scss";

export const TemTwoProfileMatching = () => {
  return (
    <section className={styles.section_profile_matching}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.matching_wrapper}>
            <h4 className={styles.title}>Profile matching</h4>
            <p className={styles.text}>
              Want to know your chances of admission in this university?
            </p>
            <Link legacyBehavior href="/signin">
              <a className="btn btn-secondary btn-bg">Check Now</a>
            </Link>
          </div>
          <div className={styles.image_wrapper}>
            <img
              src={getAssets("assets/images/uni-profile/profile-matching.png")}
              alt="profile-matching"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TemTwoProfileMatching;
